export enum KybRequestProcess {
  SystemDefaultForm = 'system-default-form',
  CustomRequestForm = 'custom-request-form',
  ThirdPartyRedirection = 'third-party-redirection',
}

export enum KybRequest {
  EntityConstitutionalDocuments = 'ENTITY_CONSTITUTIONAL_DOCUMENTS',
  RegistryExtract = 'REGISTRY_EXTRACT',
  EntityGroupOwnershipDiagram = 'ENTITY_GROUP_OWNERSHIP_DIAGRAM',
  CustomRequest = 'CUSTOM_REQUEST',
}
